import LzMCrud from '@lz-models/crud/Crud';

const config = new LzMCrud({
    ident: 'meshes',
    baseRoute: '/params/meshes',
    fields: {
        grain_id: { type: 'reference', required: true, refTableName: 'grains' },
        name: { size: 100, type: 'string', required: true },
        is_active: { type: 'boolean', default: true },
    },
    listingColumns: {
        grain_name: { label: 'Grain', sortable: true, alignment: 'left' },
        name: { label: 'Name', sortable: true, alignment: 'left' },
    },
    addFormInputs: {
        grain_id: { label: 'Grain' },
        name: { label: 'Name' },
        is_active: { label: 'Active', type: 'switch' },
    },
    viewFormFields: {
        grain_name: { label: 'Grain' },
        name: { label: 'Name' },
        is_active: { label: 'Active', displayFunction: (val) => !!val ? 'Active' : 'In-Active' },
    },
    editFormInputs: {
        grain_id: { label: 'Grain' },
        name: { label: 'Name' },
        is_active: { label: 'Active', type: 'switch' },
    },
});

export default config;
